module.exports = __webpack_public_path__ + "img/head-bg.3e2932a3.jpg";